import Global from './Global';
import { changeLanguage } from './lang';
import EventDispatcher from './EventDispatcher';
import jQuery from 'jquery';
const $ = jQuery;

const muteBtn = '/assets/UI/Mute.png';
const unMuteBtn = '/assets/UI/Sound.png';
function notify3D() {
  Global.events.dispatchEvent({
    type: 'GAMESCENE_EVENTS',
    message: {
      event_type: 'clear_3d',
      data: {},
    },
  });
}
function initMenu(eventRegisterFn) {
  document.querySelector('#homeBtn')?.addEventListener('click', () => {
    // window.myEmitter.emit('menu_event', 'menu_home');
    showHome();
  });
  document.querySelector('.recomonded')?.addEventListener('click', () => {
    showMenuNav();
  });
  document.querySelector('#menu_profile')?.addEventListener('click', () => {
    // hidePopup();
    window.myEmitter.emit('show_page', 'profile_screen');
  });
  document.querySelector('#menu_code')?.addEventListener('click', () => {
    window.myEmitter.emit('menu_event', 'showCode');
  });
  document
    .querySelector('#menu_nav_close')
    .addEventListener('click', hideMenuNav);
  document
    .querySelector('#navContainer')
    ?.addEventListener('click', hideMenuNavTwo);

  document.querySelector('#what')?.addEventListener('click', () => {
    $('.menuBox').hide();
    $('#whatsGoingOn').show();
    Global.clickUpdater('whatBtn');
    hideMenuNav();
    document.querySelector('#menuPopup_scr').style.display = 'flex';
    setTimeout(() => {
      document.querySelector('#menuPopup_scr').classList.add('active');
    }, 50);
  });

  document.querySelector('#how')?.addEventListener('click', () => {
    $('.menuBox').hide();
    $('#howToPickASide').show();
    Global.clickUpdater('howBtn');
    hideMenuNav();
    document.querySelector('#menuPopup_scr').style.display = 'flex';
    setTimeout(() => {
      document.querySelector('#menuPopup_scr').classList.add('active');
    }, 50);
  });
  document.querySelector('#howToPlayGame')?.addEventListener('click', () => {
    $('.menuBox').hide();
    $('#howToPlay').show();
    Global.clickUpdater('howToPlayBtn');
    hideMenuNav();
    document.querySelector('#menuPopup_scr').style.display = 'flex';
    setTimeout(() => {
      document.querySelector('#menuPopup_scr').classList.add('active');
    }, 50);
  });
  document.querySelector('#history')?.addEventListener('click', () => {
    window.myEmitter.emit('menu_event', 'purchaseHistory');
  });
  document.querySelector('#orders')?.addEventListener('click', () => {
    window.myEmitter.emit('menu_event', 'yourOrder');
  });
  document.querySelector('#addPointsNav')?.addEventListener('click', () => {
    setTimeout(() => {
      window.myEmitter.emit('menu_event', 'showCode');
    }, 500);
  });
  document.querySelector('#closeMenuPopUp')?.addEventListener('click', () => {
    closePopUp();
  });
  document.querySelector('#close2')?.addEventListener('click', () => {
    window.myEmitter.emit('hidePopup');
  });
  document.querySelector('#tnc')?.addEventListener('click', () => {
    $('.menuBox').hide();
    document
      .querySelectorAll('.UAEENG, .UAEARB, .BHRENG, .BHRARB, .KSAENG, .KSAARB')
      .forEach((el) => {
        el.style.display = 'none';
      });
    $('#termsAndConditions').show();
    Global.clickUpdater('tncBtn');
    setTimeout(() => {
      if (Global.country == 'UAE') {
        document.querySelector(`.UAE${Global.lang}`).style.display = 'block';
      } else if (Global.country == 'KSA') {
        document.querySelector(`.KSA${Global.lang}`).style.display = 'block';
      } else {
        document.querySelector(`.BHR${Global.lang}`).style.display = 'block';
      }
    }, 50);
    document.querySelector('#menuPopup_scr').style.display = 'flex';
    setTimeout(() => {
      document.querySelector('#menuPopup_scr').classList.add('active');
    }, 50);
  });
  document.querySelectorAll('.menu-item').forEach((el) => {
    el.addEventListener('click', function () {
      document
        .querySelectorAll('.menu-item')
        .forEach((item) => item.classList.remove('active'));
      this.classList.add('active');
    });
  });
  document.querySelectorAll('.nav-item').forEach((el) => {
    el.addEventListener('click', function () {
      document
        .querySelectorAll('.nav-item')
        .forEach((item) => item.classList.remove('active'));
      this.classList.add('active');
    });
  });
  document.querySelectorAll('.btn_toggle').forEach((el) => {
    el.addEventListener('click', function () {
      document
        .querySelectorAll('.btn_toggle')
        .forEach((item) => item.classList.remove('active'));
      this.classList.add('active');

      if (this.classList.contains('en')) {
        Global.lang = 'ENG';
        Global.clickUpdater('english');
      } else {
        Global.lang = 'ARB';
        Global.clickUpdater('arabic');
      }

      // window.myEmitter.emit('addDisplayProducts');
      // window.myEmitter.emit('show_page', 'home_screen');
      changeLanguage();
    });
  });
  document.querySelector('#faq')?.addEventListener('click', () => {
    Global.clickUpdater('faqBtn');
    window.open('https://www.oreostayplayful.com/privacy-policy/', '_blank');
  });
  document.querySelector('#contact')?.addEventListener('click', () => {
    window.myEmitter.emit('show_page', 'contactUs_screen');
  });
  let vbool = true;
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      if (Global.volumeBool) {
        document.querySelector('#BG_Music').play();
      }
    } else {
      document.querySelector('#BG_Music').pause();
      // document.querySelector('#GameBG_Music').pause()
    }
  });
  document.querySelector('body').addEventListener('click', () => {
    if (vbool) {
      vbool = false;
      Global.volumeBool = true;
      document.querySelector('#volumeBtn').querySelector('img').src = unMuteBtn;
      document.querySelector('#BG_Music').play();
      //   document.querySelector('.sound_off').style.opacity = 0;
    }
  });
  $(document).on(
    'click',
    '#voteNow,#selectionNext,#backToHomeScoreLooser_btn,#backToHomeScore_btn,#backToHomeResult_btn,#signUpError_btn, #signInError_btn, #submit_btn, #checkbox, #checkbox2, #gameInst_btn,#leaderboard_btn,#playToWin_btn,#start_btn,#homeBtn,.btn_toggle.en,.btn_toggle.ar,#menu_home,.recomonded,#menu_profile,#menu_code,#menu_nav_close,#navContainer,#what,#navContainer,#what,#menuPopup_scr,#menuPopup_scr,#how,#menuPopup_scr,#menuPopup_scr,#howToPlayGame,#menuPopup_scr,#menuPopup_scr,#history,#orders,#addPointsNav,#tnc,#closeMenuPopUp,#close2,.menu-item,.nav-item,.btn_toggle,#faq,#contact,#volumeBtns,#volumeBtn,#playerNameSubmit_btn,#Oneplayer_btn,#Twoplayer_btn,#selectFlavourNext_btn,#hazelnutSide,#chocolateSide,#signin_btn,#checkboxLogin,#checkbox2Login,#checkbox3Login,#backSignIn_btn,#submit_btn,#checkbox,#checkbox2,#checkbox3,#backSignUp_btn,#gotoSignUp_btn,#gotoSignIn_btn,#signUpToPlay_btn,#tapToTwist_btn',
    () => {
      const clickSound = document.getElementById('click_Music');
      if (clickSound && Global.volumeBool) {
        // clickSound.currentTime = 0;
        clickSound
          .play()
          .catch((err) => console.warn('Audio play error:', err));
      }
    }
  );
  if (document.querySelector('#volumeBtn') == null) return false;

  document.querySelector('#volumeBtns').addEventListener('click', () => {
    if (Global.volumeBool) {
      Global.volumeBool = false;
      document.querySelector('#BG_Music').pause();
      document.querySelector('#volumeBtn').querySelector('img').src = muteBtn;
      document.querySelector('#volumeBtns').querySelector('img').src = muteBtn;
    } else {
      Global.volumeBool = true;
      // document.querySelector('#BG_Music').currentTime = 0;
      document.querySelector('#BG_Music').play();
      document.querySelector('#volumeBtn').querySelector('img').src = unMuteBtn;
      document.querySelector('#volumeBtns').querySelector('img').src =
        unMuteBtn;
    }
    Global.clickUpdater('volumeBtn');
  });
  document.querySelector('#volumeBtn').addEventListener('click', () => {
    if (Global.volumeBool) {
      Global.volumeBool = false;
      document.querySelector('#BG_Music').pause();
      document.querySelector('#volumeBtn').querySelector('img').src = muteBtn;
      document.querySelector('#volumeBtns').querySelector('img').src = muteBtn;
    } else {
      Global.volumeBool = true;
      // document.querySelector('#BG_Music').currentTime = 0;
      document.querySelector('#BG_Music').play();
      document.querySelector('#volumeBtn').querySelector('img').src = unMuteBtn;
      document.querySelector('#volumeBtns').querySelector('img').src =
        unMuteBtn;
    }
    Global.clickUpdater('volumeBtn');
  });
}

function closePopUp(params) {
  Global.clickUpdater('closeMenuPopUp');
  document.querySelector('#menuPopup_scr').classList.remove('active');
  setTimeout(() => {
    document.querySelector('#menuPopup_scr').style.display = 'none';
  }, 500);
}
function showMenu() {
  // document.querySelector("#app_menu").classList.add('active');
  if (document.querySelector('#app_menu')) {
    document.querySelector('#app_menu').classList.add('active');
  }
}
function hideMenu() {
  if (document.querySelector('#app_menu')) {
    document.querySelector('#app_menu').classList.remove('active');
  }
}
function showMenuNav() {
  //   hidePopup();
  if (document.querySelector('#app_menu_nav')) {
    document.querySelector('#app_menu_nav').classList.add('active');
    Global.clickUpdater('showMenuBtn');
  }
}
function hideMenuNav() {
  if (document.querySelector('#app_menu_nav')) {
    document.querySelector('#app_menu_nav').classList.remove('active');
    Global.clickUpdater('closeNavBtn');
  }
}
function hideMenuNavTwo() {
  if (document.querySelector('#app_menu_nav')) {
    document.querySelector('#app_menu_nav').classList.remove('active');
  }
}

function showHome() {
  // hidePopup();
  hideMenuNav();
  notify3D();
  Global.events.dispatchEvent({
    type: 'LOADER_EVENTS',
    message: {
      event_type: 'switch_page',
      data: {
        screenKey: 'Home',
      },
    },
  });
  // window.myEmitter.emit(`show_page`, 'home_screen');
  // window.myEmitter.emit(`addDisplayProducts`);
}

function hidePopup() {
  // $('.codeBox').removeClass('active');
  // document.getElementById('code').value = '';
  // document.querySelector('.codeError').style.opacity = 0;
  // document.getElementById('popup_screen').classList.remove('active');
}
export { initMenu, showMenu, hideMenu, showMenuNav, hideMenuNav };
